module.exports = __webpack_public_path__ + "img/creswellhall-v-474x632.8a8567d6.jpg";